export default {
  getBurgerMenuState: (state) => state.burgerMenuState,
  getCurrenciesSign: (state) => state.currenciesSign,
  getZIndexBlock: (state) => state.zIndexBlock,
  getPackages: (state) => state.packages,
  getPackagesLoading: (state) => state.packagesLoading,
  getActiveHeaderSection: (state) => state.activeHeaderSection,
}